module.exports = __webpack_public_path__ + "img/concrete-hole-decal-16.6dc2579c.png";